/* unplugin-vue-components disabled */import { render } from "./MigratorPage.vue?vue&type=template&id=7ce56c90"
import script from "./MigratorPage.vue?vue&type=script&lang=js"
export * from "./MigratorPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__